// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"b7c91527","269":"f0700aeb","370":"7cf079c2","603":"b5837b96","761":"f6e0bf70","925":"9806e769"}[chunkId] + ".chunk.js";
};